const { marked } = require('marked');

// The text pages' markdown as HTML (WHIT-470). Kept out of TextPage.tsx so
// `node --test` can load it without React.
const renderMarkdown = markdown => marked.parse(markdown, { async: false });

module.exports = { renderMarkdown };
